<div class="layout-wrapper">
  <div class="layout-topbar" [class._sidebar-visible]="isShowSidebar">
    <app-topbar hasSidebar/>
  </div>
  <app-menu />
  <div class="layout-main-container">
    <div class="layout-main" [class._sidebar-visible]="isShowSidebar">
      <div class="layout-main-inner">
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</div>
